import React, { useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import {
  useSourceNifiCheckMutation,
  useSourceSquidMutation,
  useSourceNifiMutation,
  stateSourceExterne,
} from "../../cdsApiSlice";
import { CustomAccordion } from "../Accordion";
import "./DataSourceExterne.scss";
import "../Accordion.scss";
import { Skeleton } from "primereact/skeleton";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button } from "primereact/button";
import { setToast } from "../../../../app/appSlice";
import { useAppDispatch } from "../../../../hooks/hooks";
import { Chip } from "primereact/chip";
import useGetCustomMetaDataWithOrganisme from "./common/getCustomMetaDataWithOrganisme";
import useGetMetaDataValue from "./common/getMetaDataValue";
import { useSecureApplication } from "../../../../hooks/KeycloackConnection";

interface SourceDetailProps {
  id: number;
  logMessage: string[];
  message: string[];
  state: stateSourceExterne | undefined;
  sourceView: any;
}

interface IErrorSourceExterne {
  value: string;
  type: string;
}

export const RenderLoading = () => {
  let valueLoadin = [
    1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19,
  ];
  return (
    <>
      <div>
        {valueLoadin.map(() => (
          <Skeleton className="m-3 w-full" />
        ))}
      </div>
    </>
  );
};

export const DataSourceExterneDetail = ({
  id,
  logMessage,
  message,
  state,
  sourceView,
}: SourceDetailProps) => {
  const [getNifiState, { data: nifiSatate, ...nifiStatus }] =
    useSourceNifiCheckMutation();
  const [postSquid, squidStatus] = useSourceSquidMutation();
  const [postNifi, postNifiStatus] = useSourceNifiMutation();
  const { findMetaDataVariable } = useGetMetaDataValue();
  const [connexion, setConnexion] = useState(true);
  const [showSourceExterne, setShowSourceExterne] = useState(true);
  const [flux, setFlux] = useState(true);
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const [showLogError, setShowLogError] = useState<boolean>(false);
  const {hasAnyPerm} = useSecureApplication()
  const errorNifi = require("../../../../assets/images/icon-warning.svg");
  const { getCustomMetaDataWithOrganisme } =
    useGetCustomMetaDataWithOrganisme();
  const defaultCustomData: string[] = [
    "source_motif_noms_fichiers",
    "source_recursif",
    "source_http_methode",
    "source_jdbc_requete",
    "source_protocole",
    "source_uri",
    "source_utilisateur",
    "source_type_donnee",
    "source_format_donnee",
    "source_famille",
    "source_organisme",
  ];

  useEffect(() => {
    getNifiState({ id: id });
  }, []);

  /***  organisme value not required, if not exist, his value is set to undefined ***/
  const organsime = useMemo(() => {
    if (
      sourceView?.source?.metadonnees?.find(
        (i: any) => i.nom === "source_organisme"
      )?.valeur
    )
      return findMetaDataVariable("source_organisme", sourceView.source);
    return undefined;
  }, [sourceView]);


  const successPostNifi = () => {
    getNifiState({ id: id });
    dispatch(
      setToast({
        title: "NiFi",
        content: `Source ${sourceView.source.nom} synchronisée avec Nifi`,
        severity: "success",
        life: 3000,
      })
    );
  };

  const userIfExist = (): string | undefined => {
    if (sourceView) {
      return sourceView.source.metadonnees.find(
        (i: any) => i.nom === "source_utilisateur"
      ).valeur;
    }
    return undefined;
  };

  const tableError = (): IErrorSourceExterne[] => {
    const tabError = [];
    if (state) {
      if (state.invalidCount === 1)
        tabError.push({
          value: "1 processeur Nifi est mal configuré",
          type: "invalidCount",
        });
      if (state.invalidCount > 1)
        tabError.push({
          value: `${state.invalidCount} processeurs Nifi sont mal configurés`,
          type: "invalidCount",
        });
      if (state.disabledCount === 1)
        tabError.push({
          value: "1 processeur Nifi est désactivé",
          type: "disabledCount",
        });
      if (state.disabledCount > 0)
        tabError.push({
          value: `${state.disabledCount} processeurs Nifi sont désactivés`,
          type: "disabledCount",
        });
      if (state.bulletins.length > 0)
        tabError.push({
          value: `${state.bulletins.length} log(s) d'erreur(s)`,
          type: "bulletins",
        });
    }

    return tabError;
  };

  const PlayButtonSquid = () => {
    if (squidStatus.isLoading)
      return (
        <Button
          className="p-button-rounded p-button-secondary p-button-outlined"
          disabled={true}
        >
          <div className="is__loading">
            <FontAwesomeIcon icon="spinner" spin /> {t("label.loading")}
          </div>
        </Button>
      );
    if (squidStatus.isError)
      return (
        <Button className="p-button-rounded p-button-secondary p-button-outlined">
          <div
            className="is__error"
            onClick={async () => {
              try {
                await postSquid({
                  id: id,
                  uri: sourceView.source.metadonnees.find(
                    (i: any) => i.nom === "source_uri"
                  ).valeur,
                }).unwrap();
              } catch {}
            }}
          >
            <FontAwesomeIcon icon="sync" /> {t("label.error")} !
          </div>
        </Button>
      );

    return (
      <Button
        className="p-button-rounded p-button-secondary p-button-outlined"
        onClick={() =>
          postSquid({
            id: id,
            uri: sourceView.source.metadonnees.find(
              (i: any) => i.nom === "source_uri"
            ).valeur,
          })
        }
      >
        <div>
          <FontAwesomeIcon icon="play" />
          &nbsp;{"Déclarer l'uri"}
        </div>
      </Button>
    );
  };

  const PlayButtonNifi = () => {
    if (postNifiStatus.isLoading)
      return (
        <Button
          className="p-button-rounded p-button-secondary p-button-outlined"
          disabled={true}
        >
          <div className="is__loading">
            <FontAwesomeIcon icon="spinner" spin /> {t("label.loading")}
          </div>
        </Button>
      );
    if (postNifiStatus.isError)
      return (
        <Button className="p-button-rounded p-button-secondary p-button-outlined">
          <div
            className="is__error"
            onClick={async () => {
              try {
                await postNifi({
                  id: id,
                  data: sourceView.source,
                }).unwrap();
                successPostNifi();
              } catch (e) {
                console.log("ERROR NIFI :");
                console.log(e);
              }
            }}
          >
            <FontAwesomeIcon icon="sync" /> {t("label.error")} !
          </div>
        </Button>
      );

    return (
      <Button
        className="p-button-rounded p-button-secondary p-button-outlined"
        onClick={async () => {
          try {
            await postNifi({
              id: id,
              data: sourceView.source,
            }).unwrap();
            successPostNifi();
          } catch (e) {
            console.log("ERROR NIFI :");
            console.log(e);
          }
        }}
      >
        <div>
          <FontAwesomeIcon icon="play" />
          &nbsp;{"Synchroniser"}
        </div>
      </Button>
    );
  };

  const styleStateSource = (mess: string): string => {
    if (mess === "Erreur") return "errorSource";
    if (mess === "Source démarée") return "startSource";
    return "";
  };

  return (
    <>
      {/* <div className="m-3"><span  className="iconSynchronise"><FontAwesomeIcon icon="check"  /></span> <span className="contentData">Source synchronisée avec Squid</span></div> */}

      {sourceView && (
        <div>
          {sourceView.source.squidUri ? (
            ""
          ) : (
            <>
              <p className="Profil-Personnel">Squid :</p>
              <div className="flex m-3 justify-content-between">
                <div className="flex align-items-center justify-content-center">
                  <img src={errorNifi.default} style={{ width: "3.2em" }} />
                </div>
                <div className="flex align-items-center justify-content-center text-sm">
                  L'URI n'a pas été déclarée dans Squid
                </div>
                {hasAnyPerm("gds.manage") && <div className="flex align-items-center justify-content-center">
                  {PlayButtonSquid()}
                </div>}
              </div>
            </>
          )}
          {nifiSatate === false ? (
            <>
              <p className="Profil-Personnel">NIFI :</p>
              <div className="flex m-3">
                <div className="flex align-items-center justify-content-center mr-6">
                  <img src={errorNifi.default} style={{ width: "3.2em" }} />
                </div>
                <div className="flex align-items-center justify-content-center text-sm">
                  La source : {sourceView.source.nom} n'est pas synchronisée
                  avec NiFi
                </div>
                {hasAnyPerm("gds.manage") && <div className="flex align-items-center justify-content-center ">
                  {PlayButtonNifi()}
                </div>}
              </div>
            </>
          ) : (
            ""
          )}

          <div className="flex flex-wrap  mb-4">
            <strong className="flex mr-3 text-lg">Etat</strong>
            {message.map((i: any) => (
              <div className="flex ml-2">
                <Chip className={styleStateSource(i)} label={i} />
              </div>
            ))}
          </div>

          {tableError().length > 0 ? (
            <div className="mb-4">
              {" "}
              <div className="mb-2 flex flex-varp">
                <div className="flex" style={{ color: "#54769a" }}>
                  Détail de l'erreur
                </div>
                <div className="flex ml-2" style={{ color: "#08365e" }}>
                  {tableError()[0].value}
                </div>
                {tableError()[0].type === "bulletins" ? (
                  <strong
                    className="flex ml-4 seeLogs"
                    onClick={() => setShowLogError(!showLogError)}
                  >
                    VOIR LES LOGS
                  </strong>
                ) : null}
              </div>
              {tableError().length > 1 ? (
                <div className="mb-2 ml-5">
                  {tableError().map((v, i) => {
                    if (i > 0) {
                      return (
                        <div className="flex" style={{ marginLeft: "5.5em" }}>
                          <div style={{ color: "#08365e" }}> {v.value} </div>
                          {v.type === "bulletins" ? (
                            <strong
                              className="flex ml-4 seeLogs"
                              onClick={() => setShowLogError(!showLogError)}
                            >
                              VOIR LES LOGS
                            </strong>
                          ) : null}
                        </div>
                      );
                    }
                  })}
                </div>
              ) : null}
              {showLogError && (
                <div className="logError">
                  {logMessage.map((value: any, i: number) => (
                    <div className="mb-2">
                      {i + 1}.{value}
                    </div>
                  ))}
                </div>
              )}
            </div>
          ) : null}

          <strong className="mt-2 mb-2 text-sm">Informations générales</strong>

          <CustomAccordion
            name={"Connexion"}
            visible={connexion}
            setter={() => {
              setConnexion(!connexion);
            }}
            bin={false}
          />
          {connexion && (
            <div className="ml-2 mt-5 mb-6">
              <div className="m-3">
                <span className="data">URI :</span>{" "}
                <span className="contentData">
                  {
                    sourceView.source.metadonnees.find(
                      (i: any) => i.nom === "source_uri"
                    ).valeur
                  }
                </span>
              </div>
              {userIfExist() ? (
                <div className="m-3">
                  <span className="data">Utilisateur :</span>{" "}
                  <span className="contentData">{userIfExist()}</span>
                </div>
              ) : null}
              <div className="m-3">
                <span className="data">Créateur :</span>{" "}
                <span className="contentData">
                  {sourceView.source.createur}
                </span>
              </div>
            </div>
          )}
          <CustomAccordion
            name={"Source Externe"}
            visible={showSourceExterne}
            setter={() => {
              setShowSourceExterne(!showSourceExterne);
            }}
            bin={false}
          />
          {showSourceExterne && (
            <div className="ml-2 mt-5 mb-6">
              <div className="m-3">
                <span className="data">Nom de la source :</span>{" "}
                <span className="contentData">{sourceView.source.nom}</span>
              </div>
              <div className="m-3">
                <span className="data"> Description : </span>{" "}
                <span className="contentData">
                  {sourceView.source.description}
                </span>
              </div>
              {/* <p>
                  Originine de la source : <b></b>
                </p> */}
              <div className="m-3">
                <span className="data">Type de donnée :</span>{" "}
                <span className="contentData">
                  {
                    sourceView.source.metadonnees.find(
                      (i: any) => i.nom === "source_type_donnee"
                    ).valeur
                  }
                </span>
              </div>
              <div className="m-3">
                <span className="data"> Format de donnée :</span>{" "}
                <span className="contentData">
                  {
                    sourceView.source.metadonnees.find(
                      (i: any) => i.nom === "source_format_donnee"
                    ).valeur
                  }
                </span>
              </div>

              {organsime && (
                <div className="m-3">
                  <span className="data"> Organisme :</span>{" "}
                  <span className="contentData">{organsime}</span>
                </div>
              )}

              {
                //display cutsom meta data only if exist
                getCustomMetaDataWithOrganisme(
                  sourceView.source,
                  defaultCustomData
                ).customMedatas.map((customMetaData) => (
                  <div className="m-3">
                    <span className="data"> {customMetaData.name} :</span>{" "}
                    <span className="contentData">{customMetaData.value}</span>
                  </div>
                ))
              }
            </div>
          )}
          <CustomAccordion
            name={"Flux d'ingestion"}
            visible={flux}
            setter={() => {
              setFlux(!flux);
            }}
            bin={false}
          />
          {flux && (
            <div className="ml-2 mt-5 mb-6">
              <div className="m-3">
                <span className="data">Domaine :</span>{" "}
                <span className="contentData">
                  {sourceView.source.domaine.libelle}
                </span>
              </div>
              <div className="m-3">
                <span className="data">SSI :</span>{" "}
                <span className="contentData">
                  {sourceView.source.sas ? "oui" : "non"}
                </span>
              </div>
              <div className="m-3">
                <span className="data">Espace de stockage :</span>{" "}
                <span className="contentData">
                  {sourceView.source?.espacesDeStockage[0]?.qName}
                </span>
              </div>
            </div>
          )}
        </div>
      )}

      {}
    </>
  );
};
